import ArticleForm from "components/organisms/ArticleForm";
import type { ReactNode } from "react";

function NewArticlePage(): ReactNode {
  return <ArticleForm creation />;
}

export default NewArticlePage;
